import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { AuthUser } from '@/features/auth/auth';

interface AuthState {
  user: AuthUser | null;
}

const initialState: AuthState = {
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<AuthUser>) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
    },
    patchPermissions: (
      state,
      action: PayloadAction<AuthUser['permissions']>
    ) => {
      if (state.user) {
        state.user.permissions = action.payload;
      }
    },
  },
});

export const { setUser, clearUser, patchPermissions } = authSlice.actions;
export default authSlice.reducer;
